/**
 * 07 / FOR INSTALLERS — scenarios + the installers-only clause (plan/04 §05,
 * plan/05 §4, §2b). The clause is a trust asset, not fine print: it must read
 * identically here, in the FAQ, and in /legal/preorder (QA greps for divergence).
 */

/** Section framing — the same shape every other section's head uses. */
export const forInstallers = {
	index: '07',
	label: 'For installers',
	heading: 'Made for the jobs your library can’t sell you.',
	intro:
		'The car that is too new, the coverage nobody patterns, the paint nobody wants a blade near. Three jobs that walk in every month, and what each one looks like once you can pattern them yourself.'
} as const;

/**
 * Each scenario carries its own two-line readout: what the catalog has for that
 * job, and what happens in your bay instead. Same labels down all three rows, so
 * the right-hand rail reads as one comparison rather than three loose captions.
 */
export const scenarios = [
	{
		index: '01',
		title: 'The launch-day EV',
		body: 'A customer books the week deliveries start. The pattern database won’t have the car for months. You scan it in the morning, flatten the front, and cut before lunch. No waiting for someone else to measure a car you already have on the lift.',
		readouts: [
			{ label: 'In the catalog', value: 'Months away' },
			{ label: 'In your bay', value: 'Same morning' }
		]
	},
	{
		index: '02',
		title: 'The partial front nobody patterns',
		body: 'The customer’s budget ends halfway up the hood. There’s no catalog entry for “partial front, this exact line.” You draw the coverage where they want it, test the stretch on screen, and cut it clean: designed, not improvised with a knife on paint.',
		readouts: [
			{ label: 'In the catalog', value: 'No entry for it' },
			{ label: 'In your bay', value: 'Cut to their line' }
		]
	},
	{
		index: '03',
		title: 'The car nobody will cut on',
		body: 'A collector car, an exotic, a fresh respray. The database has nothing, and nobody is putting a blade near that paint. You scan the panel, build the pattern off the scan, and cut it on the plotter, so the film is the only thing that ever touches the car.',
		readouts: [
			{ label: 'In the catalog', value: 'Nothing at all' },
			{ label: 'In your bay', value: 'No blade on paint' }
		]
	}
] as const;

/** WHO WE SELL TO — Option 1 (D12), plan/05 §2b. */
export const whoWeSellTo = {
	label: 'Who we sell to',
	statement:
		'Sold to installers. No one else. PPF Engine licenses go to installation shops and independent installers only, never to PPF film manufacturers. Your scans stay on your machine, your patterns stay your business.',
	/** Short form for the pricing card / trust lines. */
	short: 'Installers only: never sold to film manufacturers.',
	/** Pair with the local-data fact wherever the clause appears. */
	localData:
		'The app runs on your own computer. Your scans and templates never leave it for our servers.',
	/** The stamp on the right of the clause's foot rule. */
	stamp: 'Local only'
} as const;

/** The credibility line (plan/04 §05, plan/00 §1 — never mention STEK). */
export const credibility =
	'Built by installers and software people in Tartu, Estonia. You get build notes from the actual developers, not a newsletter robot.';
